import React from 'react';
import { Badge, BadgeProps } from 'react-bootstrap';
import { ActionRequestStatuses, tActionRequestStatus, getActionRequestStatusVariant } from '@models/ActionRequest';

type Props = BadgeProps & {
  status: ActionRequestStatuses;
};

const ActionRequestBadge = ({ status, ...rest }: Props) => {
  const variant = getActionRequestStatusVariant(status);

  return (
    <Badge {...rest} bg={variant}>
      {tActionRequestStatus(status)}
    </Badge>
  );
};

export { ActionRequestBadge };
